module.exports = __webpack_public_path__ + "img/citas-coordinadas-no-completadas.d061e4cd.svg";